import {
  listenToParentSendMessage,
  type SendMessageBehavior,
} from '@trimble-agentic-external-npm-local/agentic-platform-sdk-iframe-typescript';
import type { ExternalSendMessageContent } from '@trimble-agentic-internal-npm-local/agentic-chat-ui';

const onParentSendMessageError = (error: Error) => {
  console.error('Parent sendMessage failed', error);
};

/** Stable subscribe fn for chat-ui `externalSendMessageSource`. */
export const subscribeToParentSendMessage = (
  handler: (
    content: ExternalSendMessageContent,
    behavior?: SendMessageBehavior
  ) => void | Promise<void>
): (() => void) =>
  listenToParentSendMessage(({ content, behavior }) => {
    void Promise.resolve(handler(content, behavior)).catch(error => {
      onParentSendMessageError(
        error instanceof Error ? error : new Error(String(error))
      );
    });
  }, onParentSendMessageError);
